import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../Components/Navbar/Navbar";
import toast from "react-hot-toast";
import Select from "react-select";
import "./Manage.css";
import {
    getBuildItem,
} from "../../Helpers/apiCalls/Manage/BuildItem";
import InputError from "../../Components/InputError/InputError";
import NoDataImg from "../../Assets/Images/no-data-img.png";
import { changeStatus, createJobOrder, getJobOrder, updateJobOrder } from "../../Helpers/apiCalls/Manage/JobOrder";
import { getType, toastStyle } from "../../Helpers/Utils/Common";
import ApproveModal from "../../Components/Modals/ApproveModal";
import { getAllItems } from "../../Helpers/apiCalls/itemsApi";
import { getAllBranches } from "../../Helpers/apiCalls/branchApi";
import { getAllEmployees } from "../../Helpers/apiCalls/employeesApi";
import Compressor from "compressorjs";
import noDataImg from "../../Assets/Images/no-data-img.png";
import upload from "../../Assets/Images/upload.png";
import Upload from "antd/es/upload/Upload";
import FileExceedModal from "../../Components/Modals/FileExceedModal";
import Modal from "antd/es/modal/Modal";
import trash from "../../Assets/Images/trash.png";
import { validateBuildItem, validateBuildItemTable } from "../../Helpers/Validation/Manage/BuildItemValidation";
import Footer from "../../Components/Footer/Footer";
/*
    -- VIEW BUILT ITEM
*/
export default function BuildItemForm({add, edit}) {
    const { Dragger } = Upload;
    const { id } = useParams();
    let navigate = useNavigate();
    const accountType = getType();
    const [isClicked, setIsClicked] = useState(false);
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [showDisapproveModal, setShowDisapproveModal] = useState(false);
    const [items, setItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [branches, setBranches] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [prevAttachments, setPrevAttachments] = useState([]);
    const [showFileExceedModal, setShowFileExceedModal] = useState(false);
    const [preview, setPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState("");
    const [materialsRequired, setMaterialsRequired] = useState([
        { id: "", quantity: "1", unit: "", unitList: [] },
    ]);
    // BUILT ITEM INFO VARIABLES
    const [employees, setEmployees] = useState([]);
    const [build, setBuild] = useState({
        branch: "1",
        item: "",
        branchTo: "",
        qty: "",
        unitId: "",
        production_date: "",
        expiration_date: "",
        batch: "",
        production_slip_no: "",
        yield: "",
        type: "item",
    });
    const [itemError, setItemError] = useState({})

    // Error Handling
    const [isError, setIsError] = useState({
        branch_from: false,
        qty: false,
        ingredients: false,
    });

    const [inactive, setInactive] = useState(true);

    async function fetchBuildItem() {
        setBuild([]);
        const response = await getJobOrder({job_order_id: id});

        if (response.data) {
            fetchItems(response.data.data[0].branch_from, response.data.data[0])
            setBuild(response.data.data[0]);
            setPrevAttachments(response.data.data[0].attachments)
        }
    }

    function handleSetUnitList(items, buildDetails) {

        var data = buildDetails.items.map((item) => {
            let itemList = items.filter(
                (info) => info.id === item.item_id
            );
            var info = item
            info.unitList = { item_units: itemList[0]?.item_units }
            info.label= item.item_name
            info.value= item.item_id
            info.name= "item_id"
            info.for= "item_id_value"
            info.item_id_value = { label: item.item_name, value: item.item_id }
            info.unit_value = item.unit + "|" + item.item_unit_id
            info.build_item_id = item.id //to save build item id
            info.id = item.item_id //to set id to item id for the table to show the item
            return info
            }
        );

        const filteredOptions = items.filter(option => {
            return !data.find(item => item.item_id === option.value);
        });
        setFilteredItems(filteredOptions);

        setMaterialsRequired(data)
    }

    // MATERIAL REQUIRED TABLE FUNCTIONS
    function handleMaterialRequiredChange(e, index, select) {
        if(select) {
            // SELECT DROPDOWN CHANGE
            const list = [...materialsRequired];
            list[index][e.name] = e.value;
            list[index][e.for] = {
                label: e.label,
                value: e.value
            };

            const unit = getUnits(e.value);
            list[index]["unitList"] = unit[0];
            list[index]["item_unit_id"] = unit[0].item_units[0].id;
            list[index]["unit"] = unit[0].item_units[0].unit_to;

            const filteredOptions = items.filter(option => {
                return !materialsRequired.find(item => item.item_id === option.value);
            });
            setFilteredItems(filteredOptions);

        } else {
            const { name, value } = e.target;
            const list = [...materialsRequired];
            list[index][name] = value;

            // if (name === "id") {
            //     const unit = getUnits(value);
            //     list[index]["unitList"] = unit[0];
            //     list[index]["item_unit_id"] = unit[0].item_units[0].id;
            //     list[index]["unit"] = unit[0].item_units[0].unit_to;

            //     const filteredOptions = items.filter(option => {
            //         return !materialsRequired.find(item => item.item_id === option.value);
            //     });
            //     setFilteredItems(filteredOptions);

            // } else 
            if(name === "unit") {
                list[index][name] = value.split("|")[0];
                list[index]["unit_value"] = value;
                list[index]["item_unit_id"] = value.split("|")[1];
            }
            setMaterialsRequired(list);
        }
    }
        console.log(items)
        console.log(materialsRequired)

    function renderTableMaterialsRequired(type) {
        return (
            <Table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Qty</th>
                        <th>Used Qty</th>
                        <th>Unit</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        materialsRequired.map(
                            (product, index) => {
                                return (
                                    <tr>
                                        <td>
                                        <Select
                                            className="text-start react-select-container"
                                            classNamePrefix="react-select"
                                            placeholder="Select Item..."
                                            options={filteredItems}
                                            value={product.item_id_value}
                                            onChange={(e) => handleMaterialRequiredChange(e, index, true)}
                                        />
                                        {/* <Form.Select
                                            name="id"
                                            id={product.id}
                                            value={product.id}
                                            onChange={(e) =>
                                                handleMaterialRequiredChange(e, index)
                                            }
                                        >
                                            <option value="">Select</option>
                                            {filteredItems.map((data) => {
                                                return (
                                                    <option value={data.id}>
                                                        {data.item_name}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select> */}
                                        {itemError[index] && itemError[index].item_id && (
                                            <div className="validity-error callout bottom">{itemError[index].item_id}</div>
                                        )}
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                name="qty"
                                                min="0"
                                                value={product.qty}
                                                onChange={(e) =>
                                                    handleMaterialRequiredChange(e, index)
                                                }
                                            />
                                            {itemError[index] && itemError[index].qty && (
                                                <div className="validity-error callout bottom">{itemError[index].qty}</div>
                                            )}
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                name="qty_used"
                                                min="0"
                                                value={product.qty_used}
                                                onChange={(e) =>
                                                    handleMaterialRequiredChange(e, index)
                                                }
                                            />
                                            {itemError[index] && itemError[index].qty_used && (
                                                <div className="validity-error callout bottom">{itemError[index].qty_used}</div>
                                            )}
                                        </td>
                                        <td>
                                            <Form.Select
                                                name="unit"
                                                id={product.id}
                                                value={product.unit_value}
                                                className={
                                                    type === "view"
                                                        ? "date-filter"
                                                        : ""
                                                }
                                                onChange={(e) =>
                                                    handleMaterialRequiredChange(e, index)
                                                }
                                                disabled={type === "view"}
                                            >
                                                {product?.unitList?.item_units?.map(
                                                    (data) => {
                                                        return (
                                                            <option
                                                                key={data.id}
                                                                value={data.unit_to + "|" + data.id}
                                                            >
                                                                {
                                                                    data.unit_to
                                                                }
                                                            </option>
                                                        );
                                                    }
                                                )}
                                            </Form.Select>
                                        </td>
                                        <td>
                                            <div className="align-middle">
                                                <img
                                                    src={trash}
                                                    alt="delete"
                                                    onClick={() =>
                                                        handleRemoveMaterialRequired(index)
                                                    }
                                                    className="cursor-pointer"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                );
                            }
                        )
                    }
                </tbody>
            </Table>
        );
    }

    function handleRemoveMaterialRequired(id) {
        const rowId = id;
        const newProductList = [...materialsRequired];
        newProductList.splice(rowId, 1);
        setMaterialsRequired(newProductList);

        const filteredOptions = items.filter(option => {
            return !newProductList.find(item => item.item_id === option.value);
        });
        setFilteredItems(filteredOptions);
    }


    const handleBuildInfoChange = (e) => {
        if (typeof e === "string") {
            setBuild((prevState) => ({
                ...prevState,
                ["item"]: e,
            }));
        } else if (e.target.name === "branch_from") {
            const { name, value } = e.target;
            setBuild((prevState) => ({
                ...prevState,
                [name]: value,
            }));
            fetchItems(value);
        } else if (e.target.name === "build_item_id"){
            const { name, value } = e.target;
            const unit = getUnits(value);
            
            setBuild((prevState) => ({
                ...prevState,
                [name]: value,
                "unitList": unit[0],
                "build_item_unit": unit[0].item_units[0].unit_to,
                "build_item_unit_id": unit[0].item_units[0].id
            }));

        } else {
            const { name, value } = e.target;
            
            setBuild((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    function getUnits(id) {
        return items.filter((item) => item.id === id);
    }


    async function fetchBranches() {
        setBranches([]);
        const response = await getAllBranches();
        var allBranches = response.data.data

        setBranches(allBranches);
    }

    async function fetchEmployees() {
        setEmployees([]);
        const response = await getAllEmployees();
        if(response.data) {
            var data = response.data.data.map((data) => {
                var info = data
                info.name = data.first_name + " " + data.last_name
                return info
            })
            setEmployees(data);
        }
    }
    
    async function fetchItems(id, buildDetails) {
        setItems([]);
        setFilteredItems([]);
        const response = await getAllItems(id);
        if(response.response){
            let items = response.response.data.map((a) => {
                return {
                    label: a.name,
                    value: a.id,
                    id: a.id,
                    name: "item_id",
                    for: "item_id_value",
                    item_name: a.name,
                    detail: a.detail,
                    type: a.type,
                    current_qty: a.item_units[0]?.current_qty ?? 0,
                    item_units: a.item_units,
                };
            });
            setItems([{name: "item_id", label: "All Items", value:""}, ...items]);
            setFilteredItems([{name: "item_id", label: "All Items", value:""}, ...items]);
            if(edit) {
                handleSetUnitList(items, buildDetails)
            }
        }
    }

    function AddMaterialRequiredBtn() {
        const newProduct = { name: "", quantity: "1", unit: "" };
        setMaterialsRequired((prevProduct) => [...prevProduct, newProduct]);
    }

    async function handleChangeStatus(status) {
        setIsClicked(true);
        const response = await changeStatus(id, status);
        if (response.data) {
            toast.success(response.data.message, {style: toastStyle()});
            if(status === "approved") {
                setShowApproveModal(false)
            } else {
                setShowDisapproveModal(false)
            }
            navigate("/builditem")
        } else {
            response.error?.response?.data?.messages.map((data) => {
                return toast.error(data);
            })
            if(status === "approved") {
                setShowApproveModal(false)
            } else {
                setShowDisapproveModal(false)
            }
            navigate("/builditem")
        }
        setIsClicked(false);
    }

    useEffect(() => {
        if(edit) {
            fetchBuildItem();
        }
        fetchBranches();
        fetchEmployees()
    }, []);


    const handleRemove = (selectedFile) => {
        var newlist = fileList.filter((file) => {
            return selectedFile.uid !== file.uid;
        });
        setFileList(newlist);
    };

    const handleBeforeUpload = (file) => {
        if (file.size > 2000000) {
            setShowFileExceedModal(true);
        } else {
            //COMPRESSING FILE
            new Compressor(file, {
                quality: 0.6,
                success: (compressedResult) => {
                    setFileList([...fileList, compressedResult]);
                },
            });
        }
        return false;
    };

    function handleRemoveItemAttachment(url) {
        
        var newList = prevAttachments.filter((data) => {return data.file_url !== url})
        setPrevAttachments(newList);
        setPreview(false)
    }

    function handleSave() {
        if(add) {
            handleSaveBuildItem()
        } else {
            handleUpdateBuildItem()
        }
    }

    async function handleSaveBuildItem() {
        var errors = validateBuildItemTable(materialsRequired)
        setItemError(errors)
        if (validateBuildItem(build, materialsRequired, setIsError) && Object.keys(errors).length === 0) {
            build.attachments = fileList
            build.status = "pending"
            const response = await createJobOrder(build, materialsRequired);
            if (response.data) {
                toast.success(response.data.message, {style: toastStyle()});
                setTimeout(() => {
                    navigate("/builditem")
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
            }
        } else {
            toast.error(
                "Please fill in all fields and check if quantity is greater than 0",
                { style: toastStyle() }
            );
        }
    }

    async function handleUpdateBuildItem() {
        // if (validateBuildItem(qty, branchFrom, materialsRequired, setIsError)) {
            build.attachments = fileList
            build.prev_files = prevAttachments
            const response = await updateJobOrder(build, materialsRequired);
            if (response.data) {
                handleChangeStatus("completed")
                toast.success(response.data.message, {style: toastStyle()});
                setTimeout(() => {
                    navigate("/builditem")
                }, 1500);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
            }
        // }
    }

    
    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"INVENTORY"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> BUILD ITEM </h1>
                    </Col>
                </Row>

                
                <div className="mt-3 edit-form">
                    <Row className="nc-modal-custom-row ">
                        <Col sm={4}>
                            Branch From
                            <span className="color-red"> *</span>
                        </Col>
                        <Col sm={4}>
                            <Form.Select
                                name="branch_from"
                                className="date-filter me-3"
                                value={build.branch_from}
                                onChange={(e) => handleBuildInfoChange(e)}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {branches.map((data) => {
                                    return (
                                        <option
                                            value={data.id}
                                        >
                                            {data.name}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                            <InputError
                                isValid={isError.branch_from}
                                message={"Branch is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Requested By
                            <span className="color-red"> *</span>
                        </Col>
                        <Col sm={4}>
                            <Form.Select
                                name="requested_by"
                                className="date-filter me-3"
                                onChange={(e) => handleBuildInfoChange(e)}
                                value={build.requested_by}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {employees.map((data) => {
                                    return (
                                        <option
                                            value={data.id}
                                        >
                                            {data.name}
                                        </option>
                                    );
                                })}
                            </Form.Select>
                            <InputError
                                isValid={isError.requested_by}
                                message={"Requested by is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Date Issued</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="date"
                                name="job_order_date"
                                value={build.job_order_date}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.job_order_date}
                                message={"Date is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>ORDER DETAILS</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Type
                            <span className="color-red"> *</span>
                        </Col>
                        <Col sm={4}>
                            <Form.Select
                                name="type"
                                className="date-filter me-3"
                                value={build.type}
                                onChange={(e) => handleBuildInfoChange(e)}
                            >
                                <option value="" hidden> Select</option>
                                <option value="item" > Build Item</option>
                                <option value="job" > Job Order</option>
                            </Form.Select>
                            <InputError
                                isValid={isError.type}
                                message={"Type is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Build Item
                            <span className="color-red"> *</span>
                        </Col>
                        <Col sm={4}>
                            <Form.Select
                                name="build_item_id"
                                className="date-filter me-3"
                                value={build.build_item_id}
                                onChange={(e) => handleBuildInfoChange(e)}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {items.map((data) => {
                                        return (
                                            <option
                                                value={data.id}
                                            >
                                                {data.item_name}
                                            </option>
                                        );
                                    })}
                            </Form.Select>
                            <InputError
                                isValid={isError.build_item_id}
                                message={"build item is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Build Quantity
                            <span className="color-red"> *</span>
                        </Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="build_item_qty"
                                value={build.build_item_qty}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.build_item_qty}
                                message={"Qty is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Branch To
                            <span className="color-red"> *</span>
                        </Col>
                        <Col sm={4}>
                            <Form.Select
                                name="branch_to"
                                className="date-filter me-3"
                                value={build.branch_to}
                                onChange={(e) => handleBuildInfoChange(e)}
                            >
                                <option value="" hidden>
                                    Select
                                </option>
                                {branches
                                    // .filter(
                                    //     (info) =>
                                    //         info.name === "Warehouse"
                                    // )
                                    .map((data) => {
                                        return (
                                            <option
                                                value={data.id}
                                            >
                                                {data.name}
                                            </option>
                                        );
                                    })}
                            </Form.Select>
                            <InputError
                                isValid={isError.branch_to}
                                message={"Branch is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Description of Work</Col>
                        <Col sm={4}>
                            <textarea
                                type="text"
                                name="description"
                                value={build.description}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.description}
                                message={"Description is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col sm={4}>Estimated Time</Col>
                        <Col sm={4}>
                            <Form.Control
                                type="text"
                                name="estimated_time"
                                value={build.estimated_time}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleBuildInfoChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.estimated_time}
                                message={"Description is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>Materials Required</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col>
                            <div className="edit-purchased-items">
                                {build?.materials_required?.length === 0 ? (
                                    <span>No Materials Found!</span>
                                ) : (
                                    renderTableMaterialsRequired()
                                )}
                                <InputError
                                    isValid={isError.items}
                                    message={"At least 1 item is required"}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Col>
                            <Button type="button" onClick={() => AddMaterialRequiredBtn()}>
                                Add Ingredient
                            </Button>
                        </Col>
                    </Row>
                   {/* <Row className="nc-modal-custom-row">
                        <Col>Materials Used</Col>
                    </Row>
                     <Row className="nc-modal-custom-row">
                        <div className="edit-purchased-items">
                            {build?.materials_used?.length === 0 ? (
                                <span>No Materials Found!</span>
                            ) : (
                                renderTableMaterialsUsed()
                            )}
                            <InputError
                                isValid={isError.ingredients}
                                message={"At least 1 ingredient is required"}
                            />
                        </div>
                    </Row> */}
                    {
                        build.status === "approved" && (
                            <>
                            <Row className="nc-modal-custom-row">
                                <Col sm={4}>Date Completed</Col>
                                <Col sm={4}>
                                    <Form.Control
                                        type="date"
                                        name="date_completed"
                                        value={build.date_completed}
                                        className="nc-modal-custom-input"
                                        onChange={(e) => handleBuildInfoChange(e)}
                                        required
                                    />
                                    <InputError
                                        isValid={isError.date_completed}
                                        message={"Date is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="nc-modal-custom-row">
                                <Col sm={4}>Time In</Col>
                                <Col sm={4}>
                                    <Form.Control
                                        type="datetime-local"
                                        name="time_in"
                                        defaultValue={build.time_in}
                                        className="react-select-container"
                                        onChange={(e) => handleBuildInfoChange(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="nc-modal-custom-row">
                                <Col sm={4}>Time out</Col>
                                <Col sm={4}>
                                    <Form.Control
                                        type="datetime-local"
                                        name="time_end"
                                        defaultValue={build.time_end}
                                        className="react-select-container"
                                        onChange={(e) => handleBuildInfoChange(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="nc-modal-custom-row">
                                <Col sm={4}>Acknowledged By</Col>
                                <Col sm={4}>
                                    <Form.Select
                                        name="acknowledge_by"
                                        className="date-filter me-3"
                                        onChange={(e) => handleBuildInfoChange(e)}
                                        value={build.acknowledge_by}
                                    >
                                        <option value="" hidden>
                                            Select
                                        </option>
                                        {employees.map((data) => {
                                                return (
                                                    <option
                                                        value={data.id}
                                                    >
                                                        {data.name}
                                                    </option>
                                                );
                                            })}
                                    </Form.Select>
                                </Col>
                            </Row>
                            {
                                accountType === "admin" && (
                                    <>
                                        <Row className="nc-modal-custom-row">
                                            <Col>Complete Information (For Admin Only)</Col>
                                        </Row>
                                        <Row className="nc-modal-custom-row">
                                            <Col sm={3}>Job Order No.</Col>
                                            <Col sm={3}>
                                                <Form.Control
                                                    type="text"
                                                    name="job_order_no"
                                                    value={build.job_order_no}
                                                    className="nc-modal-custom-input"
                                                    onChange={(e) => handleBuildInfoChange(e)}
                                                    required
                                                />
                                                <InputError
                                                    isValid={isError.job_order_no}
                                                    message={"Job Order No. is required"}
                                                />
                                            </Col>
                                            <Col sm={3}>Schedule Date</Col>
                                            <Col sm={3}>
                                                <Form.Control
                                                    type="datetime-local"
                                                    name="schedule_date"
                                                    value={build.schedule_date}
                                                    className="nc-modal-custom-input"
                                                    onChange={(e) => handleBuildInfoChange(e)}
                                                />
                                                <InputError
                                                    isValid={isError.schedule_date}
                                                    message={"Job order no. is required"}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="nc-modal-custom-row">
                                            <Col sm={3}>Job Requesting To</Col>
                                            <Col sm={3}>
                                                <Form.Control
                                                    type="text"
                                                    name="job_requesting_to"
                                                    value={build.job_requesting_to}
                                                    className="nc-modal-custom-input"
                                                    onChange={(e) => handleBuildInfoChange(e)}
                                                    required
                                                />
                                                <InputError
                                                    isValid={isError.job_requesting_to}
                                                    message={"Job requesting to is required"}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="nc-modal-custom-row">
                                            <Col sm={3}>Remarks</Col>
                                            <Col >
                                                <textarea
                                                    type="text"
                                                    name="remarks"
                                                    value={build.remarks}
                                                    className="nc-modal-custom-input"
                                                    onChange={(e) => handleBuildInfoChange(e)}
                                                    required
                                                />
                                                <InputError
                                                    isValid={isError.remarks}
                                                    message={"Remarks is required"}
                                                />
                                            </Col>
                                        </Row>
                                    </>
                                )
                            }
                            </>
                        )
                    }
                    {
                        edit && (
                        <>
                        <div className="mt-4 noPrint mx-3">
                            <Row className="review-data mb-2">
                                FILE ATTACHMENTS
                            </Row>
                            <Row className="">
                                {
                                    prevAttachments && prevAttachments.map((attachment) => (
                                        <Col xs={1} onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}} className="cursor-pointer preview-container">
                                            <img src={attachment.file_url}  className="img-preview"/>
                                        </Col>
                                    ))
                                }
                                {
                                    !prevAttachments || prevAttachments.length === 0 && 
                                    <Col xs={1}>
                                    <div className="no-data-cont d-flex justify-content-left preview-container">
                                        <img src={noDataImg} alt="no data found" className="img-preview"/>
                                    </div>
                                    </Col>
                                }
                            </Row>
                        </div>
                        </>
                        )
                    }
                    <Row className="mt-4 mb-2">
                        <Col>
                            <Dragger
                                fileList={fileList}
                                onRemove={handleRemove}
                                beforeUpload={handleBeforeUpload}
                                multiple={false}
                                listType="picture"
                                progress={{ showInfo: true }}
                            >
                                <img src={upload} className="cursor-pointer" />
                                <p className="ant-upload-text">
                                    Click or drag file to this area to upload
                                </p>
                            </Dragger>
                        </Col>
                    </Row>
                </div>
                <div className="d-flex justify-content-end pt-5 pb-3">
                    <button
                        type="button"
                        className="button-secondary me-3"
                        onClick={() => navigate("/builditem")}
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className="button-primary"
                        onClick={() => handleSave()}
                    >
                        Save
                    </button>
                </div>
            </div>
            <ApproveModal
                show={showApproveModal}
                hide={() => setShowApproveModal(false)}
                type="approve"
                text="approve this job order"
                handler={() => handleChangeStatus("approved")}
                isClicked={isClicked}
            />
            <ApproveModal
                show={showDisapproveModal}
                hide={() => setShowDisapproveModal(false)}
                type="disapprove"
                text="disapprove this job order"
                handler={() => handleChangeStatus("reject")}
                isClicked={isClicked}
            />
            <Modal open={preview} title={""} footer={null} onCancel={()=>setPreview(false)}>
                <Row className="justify-content-center">
                    <img
                        alt="example"
                        style={{
                        width: '100%',
                        }}
                        src={previewFile}
                    />
                    <div className="mt-2 d-flex justify-content-center">
                        <img
                            src={trash}
                            alt="trash"
                            onClick={() => handleRemoveItemAttachment(previewFile)}
                            className="cursor-pointer"
                        />
                    </div>
                </Row>
            </Modal>
            <FileExceedModal
                show={showFileExceedModal}
                onHide={() => setShowFileExceedModal(false)}
                size="2MB"
            />
            <Footer/>
        </div>
    );
}
